import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function Authselectscreen() {
  const navigate = useNavigate();
  const [selrole, setSelrole] = useState("");
  return (
    <>
      <div className={`navbar visible`}>
        <div className='navbar-container'>
          <div className='navbar-logo-left'>
            <Link to='/dashboard' className='navbar-logo'>
              ProfixExpress
            </Link>
          </div>
        </div>
      </div>
      <div className='bookingpagecnt'>
        <div className="thespacee"></div>
        <div className="thespacee"></div>
        <div className='thebookingbox'>
          <h1 className='bookingtitlee'>Join as a client or technician</h1>
          <div className='thespace'></div>
          <div className='theboxselectcnt'>
            <div
              className={`theboxselect ${selrole === "client" && "clientbx"}`}
              onClick={() => setSelrole("client")}
            >
              <div
                className={`tboxs ${selrole === "client" && "clientbxt"}`}
              ></div>
              <p className='theboxselectext'>I'm a client, hiring for a task</p>
            </div>
            <div
              className={`theboxselect ${
                selrole === "technician" && "clientbx"
              }`}
              onClick={() => setSelrole("technician")}
            >
              <div
                className={`tboxs ${selrole === "technician" && "clientbxt"}`}
              ></div>
              <p className='theboxselectext'>
                I'm a technician, looking for work
              </p>
            </div>
          </div>
          <div className='thespace'></div>

          {selrole === "client" && (
            <button
              className='crtbtn'
              onClick={() => navigate("/client/signup")}
            >
              Create Account
            </button>
          )}
          {selrole === "technician" && (
            <button
              className='crtbtn'
              onClick={() => navigate("/technician/signup")}
            >
              Apply as a Technician
            </button>
          )}

          <p className='alreadyaccont'>
            Already have an account?{" "}
            <span onClick={() => navigate("/login")}>Log In</span>
          </p>
        </div>
      </div>
    </>
  );
}

export default Authselectscreen;
